import { render } from "./DealerPurchasePanel.vue?vue&type=template&id=dcec2c78&scoped=true"
import script from "./DealerPurchasePanel.vue?vue&type=script&lang=js"
export * from "./DealerPurchasePanel.vue?vue&type=script&lang=js"

import "./DealerPurchasePanel.vue?vue&type=style&index=0&id=dcec2c78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcec2c78"]])

export default __exports__